import { useIsSSR } from '@react-aria/ssr';
import { useGlobalListeners } from '@react-aria/utils';

/**
 * Tracks the document’s visibility state. The document may be "hidden" when
 * e.g. the user switches tabs or minimizes the window.
 */
export function useDocumentVisibility(
  props: {
    onChange?: (visibility: DocumentVisibilityState) => void;
    onVisible?: () => void;
    onHidden?: () => void;
  } = {}
) {
  const { addGlobalListener } = useGlobalListeners();

  if (useIsSSR() || typeof document === 'undefined') {
    return;
  }

  addGlobalListener(document, 'visibilitychange', () => {
    props.onChange?.(document.visibilityState);

    if (document.visibilityState === 'visible') {
      props.onVisible?.();
    } else {
      props.onHidden?.();
    }
  });
}
